module.exports = __webpack_public_path__ + "img/parthner-10.c7186c6c.svg";